import Vue from '../externals/vue';
import numberOrdinal from '../utils/numberOrdinal.js';
Vue.filter('numberOrdinal', numberOrdinal);
